export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6892.286bd0d7.jpg";